import {ErrorHandler, Injectable} from '@angular/core';
import {HttpErrorResponse} from '@angular/common/http';

@Injectable()
export class ErrorHandlerService implements ErrorHandler {

  // TODO: Error handling implementation missing

  handleError(error: any): void {
    if (error instanceof HttpErrorResponse) {
      console.error('**** Error Status --' + error.status);
    } else {
      console.log('----' + error);
    }

  }
}
